import styled from "@emotion/styled";
import { Text } from "components/general/Text";
import ShockedFace from "../../img/trade-interface/shocked_face.svg?react";
import WarningTriangle from "../../img/trade-interface/WarningTriangle.svg?react";
import { css } from "@emotion/react";

export interface WarningOrErrorProps {
  type: "warning" | "error";
  title: string;
  body: React.ReactNode | string;
  isOrderError?: boolean;
  isTradeSizeError?: boolean;
}

export const WarningOrError = ({ type, title, body, isTradeSizeError }: WarningOrErrorProps) => {
  const color = type === "error" ? "#FF5757" : "#FFDA57";
  return (
    <Container color={color} isTradeSizeError={!!isTradeSizeError}>
      <SubContainer>
        <Title titleText={title} type={type} />
        <Body body={body} />
      </SubContainer>
    </Container>
  );
};

// Sub-components

const Container = styled.div<{ color: string; isTradeSizeError: boolean }>(
  ({ color, isTradeSizeError }) => {
    return {
      width: "100%",
      padding: isTradeSizeError ? "14px 24px" : "0px 24px 0px 24px",

      display: "flex",
      gap: 10,
      alignItems: "center",
      justifyContent: "center",
      color,
    };
  }
);

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
`;

const Title = ({ titleText, type }: { titleText: string; type: "warning" | "error" }) => {
  return (
    <Text
      textStyle="Title"
      size="XS"
      textCss={css`
        display: flex;
        align-items: center;
        gap: 4px;
      `}
    >
      {type === "error" ? (
        <ShockedFace style={{ minWidth: 20, minHeight: 20 }} width={20} height={20} />
      ) : (
        <WarningTriangle />
      )}
      {titleText}
    </Text>
  );
};
const Body = ({ body }: { body: React.ReactNode | string }) => {
  return (
    <Text
      textStyle="Paragraph"
      size="Large"
      textCss={css`
        text-align: center;
      `}
    >
      {body}
    </Text>
  );
};
